import { format } from 'date-fns'
import type {
  AppointmentStatus,
  Location,
  User,
  VisitType,
} from '@shared/schemas'

export interface BookingsFilters {
  selectedDate: string
  selectedLocation?: Location
  selectedVisitType?: VisitType
  selectedStatus?: AppointmentStatus
  selectedDoctorId?: string
  selectedPatientId?: string
  selectedCompanyId?: string
  dailyNoteCategory: 'work' | 'sport'
  viewMode: 'agenda' | 'multi-agenda'
  userId?: string
}

export interface BookingsVariables extends Record<string, unknown> {
  filters: BookingsFilters
  isNoteModalOpen: boolean
  exportPatientIds: Array<string>
}

export const bookingsVariables: BookingsVariables = {
  filters: {
    selectedDate: '',
    dailyNoteCategory: 'work',
    viewMode: 'multi-agenda',
  },
  isNoteModalOpen: false,
  exportPatientIds: [],
}

export function getBookingsVariables(user: User): BookingsVariables {
  const doctorId = user.role === 'doctor' ? user.uid : ''
  return {
    filters: {
      selectedDate: format(new Date(), 'yyyy-MM-dd'),
      viewMode: user.role === 'doctor' ? 'agenda' : 'multi-agenda',
      selectedLocation: undefined,
      selectedVisitType: undefined,
      selectedStatus: undefined,
      selectedCompanyId: user.companyId ?? '',
      selectedPatientId: '',
      dailyNoteCategory: 'work',
      selectedDoctorId: doctorId,
      userId: doctorId,
    },
    isNoteModalOpen: false,
    exportPatientIds: [],
  }
}
